import CrudCustom from '../../../libs/custom/CrudCustom';

let PengenaanPajakService = new CrudCustom('/pengenaan-pajaks');
export default PengenaanPajakService;
